
import React from 'react';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import data from './activities-data'
import "./Activities.css";
import Faq from "../../components/Faqs/Faqs";

const ActivitiesPage = () => {
  return (
    <div>
     <NavBar></NavBar>
     <div className="activities-header">
        <div className="activities-header-body" >
            <h1 className="activities-heading">
                Our Activities
            </h1>
            <p className="activities-paragraph">
                We specialize in a diverse range of activities, including custom software development, 
                system integration, and robust IT solutions to optimize business processes and enhance overall efficiency.
            </p>
        </div>
     </div>
     <div className="activity-list-container">
        {
            data.map((value) => {
                return(
                    <div className="activity-card" key={value.title}>
                        <div className='activity-card-body'>
                            <div className='activity-icon'>{value.icon}</div>
                            <h3 className='activity-title'>{value.title}</h3>
                            <p className='activity-text'>{value.text}</p>
                        </div>
                    </div>
                )
            })
        }
     </div>
     <Faq></Faq>
     <Footer></Footer>
    </div>
  )
}

export default ActivitiesPage